import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const stepurchaseApi = createApi({
	reducerPath: "stepurchaseApi",
	baseQuery: btBaseQuery,
	tagTypes: ["STEPurchase"],

	endpoints: (builder) => ({
		getSTEPurchases: builder.query<st_epurchase[], string>({
			query: (cid) => `stepurchase/${cid}`,
			providesTags: ["STEPurchase"],
		}),
		getSTEPurchaseById: builder.query<st_epurchase, string>({
			query: (id) => `stepurchase/byid/${id}`,
			providesTags: ["STEPurchase"],
		}),
		insertSTEPurchase: builder.mutation({
			query: (stepurchase) => ({
				url: `/stepurchase/`,
				method: "POST",
				body: stepurchase,
			}),
			invalidatesTags: ["STEPurchase"],
		}),
		updateSTEPurchase: builder.mutation({
			query: (stepurchase) => ({
				url: `/stepurchase/`,
				method: "PUT",
				body: stepurchase,
			}),
			invalidatesTags: ["STEPurchase"],
		}),
		deleteSTEPurchase: builder.mutation({
			query: (stepurchase) => ({
				url: `/stepurchase/${stepurchase.pr_id}`,
				method: "DELETE",
				body: stepurchase,
			}),
			invalidatesTags: ["STEPurchase"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetSTEPurchasesQuery,
	useGetSTEPurchaseByIdQuery,
	useInsertSTEPurchaseMutation,
	useUpdateSTEPurchaseMutation,
	useDeleteSTEPurchaseMutation,
} = stepurchaseApi;
